import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      className="inline-flex items-center rounded-full border border-tara-gold/30 bg-white/75 p-1 backdrop-blur shadow-soft"
      data-testid="language-switcher"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-all ${
            lang === l.code
              ? "bg-gradient-to-r from-tara-gold to-tara-vermilion text-white shadow-soft"
              : "text-tara-body hover:text-tara-sindoor"
          }`}
          data-testid={`lang-btn-${l.code}`}
          aria-pressed={lang === l.code}
        >
          {compact ? l.short : l.label}
        </button>
      ))}
    </div>
  );
}
